import { FC, Fragment, memo } from 'react';
import {
  SkeletonWrapper,
  GroupWrapper,
  MetersTitleWrapper,
  MetersAvatarWrapper,
  RowsColumn,
  MetersButtonsWrapper,
} from './skeleton.styled';
import { Skeleton } from '../../components-v4';
import { useResponsive } from '../../../../hooks';

export const MetersSkeleton: FC = memo(() => {
  const { viewport } = useResponsive();
  let array = [1, 2, 3];

  return (
    <SkeletonWrapper>
      <Skeleton
        width={'120px'}
        height={'24px'}
        style={{ marginBottom: '16px' }}
      />

      {array.map((item, i) => (
        <Fragment key={i}>
          <MetersTitleWrapper>
            <MetersAvatarWrapper>
              <Skeleton
                width={viewport.mobile ? '40px' : '48px'}
                height={viewport.mobile ? '40px' : '48px'}
              />
              <RowsColumn style={{ gap: '4px' }}>
                <Skeleton
                  width={viewport.mobile ? '180px' : '120px'}
                  height={viewport.mobile ? '20px' : '24px'}
                />
                <Skeleton
                  width={viewport.mobile ? '100px' : '120px'}
                  height={viewport.mobile ? '16px' : '20px'}
                />
              </RowsColumn>
            </MetersAvatarWrapper>
            <Skeleton
              width={viewport.mobile ? '60px' : '120px'}
              height={viewport.mobile ? '20px' : '24px'}
            />
          </MetersTitleWrapper>
          <GroupWrapper style={{ marginBottom: '8px' }}>
            <RowsColumn style={{ gap: '8px' }}>
              <Skeleton
                width={viewport.mobile ? '100px' : '120px'}
                height={viewport.mobile ? '16px' : '20px'}
              />
              <Skeleton
                width={viewport.mobile ? '100px' : '120px'}
                height={viewport.mobile ? '20px' : '24px'}
              />
            </RowsColumn>
            <RowsColumn
              style={{
                gap: '8px',
                flexDirection: 'column-reverse',
                height: '100%',
              }}
            >
              <Skeleton
                width={viewport.mobile ? '160px' : '180px'}
                height={viewport.mobile ? '20px' : '24px'}
              />
            </RowsColumn>
          </GroupWrapper>
          <GroupWrapper style={{ marginBottom: '16px' }}>
            <RowsColumn style={{ gap: '8px' }}>
              <Skeleton
                width={viewport.mobile ? '100px' : '120px'}
                height={viewport.mobile ? '16px' : '20px'}
              />
              <Skeleton
                width={viewport.mobile ? '100px' : '120px'}
                height={viewport.mobile ? '20px' : '24px'}
              />
            </RowsColumn>
            <RowsColumn
              style={{
                gap: '8px',
                flexDirection: 'column-reverse',
                height: '100%',
              }}
            >
              <Skeleton
                width={viewport.mobile ? '160px' : '180px'}
                height={viewport.mobile ? '20px' : '24px'}
              />
            </RowsColumn>
          </GroupWrapper>
        </Fragment>
      ))}

      <MetersButtonsWrapper isMobile={viewport.mobile}>
        <Skeleton width={'100%'} height={'48px'} />
        <Skeleton width={'100%'} height={'48px'} />
      </MetersButtonsWrapper>
    </SkeletonWrapper>
  );
});
